var map = {
	"./1.json": "ANFV",
	"./10.json": "PBK4",
	"./11.json": "o+B8",
	"./12.json": "8QeM",
	"./13.json": "n8BK",
	"./14.json": "IZLK",
	"./15.json": "VDqp",
	"./16.json": "65Qj",
	"./17.json": "OvjK",
	"./18.json": "daSK",
	"./19.json": "N1w9",
	"./2.json": "HTxI",
	"./20.json": "Y1Pr",
	"./21.json": "htI5",
	"./22.json": "4V+y",
	"./23.json": "gfkt",
	"./24.json": "h698",
	"./25.json": "dgH1",
	"./26.json": "vnHd",
	"./27.json": "CBaG",
	"./28.json": "FaBM",
	"./29.json": "3CD+",
	"./3.json": "tIyT",
	"./30.json": "vkYi",
	"./31.json": "JqjT",
	"./4.json": "UFYS",
	"./5.json": "R5TJ",
	"./6.json": "zlGq",
	"./7.json": "Y6wm",
	"./8.json": "5otd",
	"./9.json": "gNQq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WsTy";


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/duzeltbakalim ^\.\/.*\.json$
// module id = WsTy
// module chunks = 4